import { useCallback, useEffect, useRef } from "react"
import { Upload } from "lucide-react"
import { Trigger } from "@/components/design-system"
import { useCsvImport } from "@/hooks/useCsvImport"

export function CsvLoadTrigger() {
  const { importFile } = useCsvImport()
  const fileInputRef = useRef<HTMLInputElement>(null)

  const openPicker = useCallback(() => {
    fileInputRef.current?.click()
  }, [])

  useEffect(() => {
    window.addEventListener("lytick:load-csv", openPicker)
    return () => window.removeEventListener("lytick:load-csv", openPicker)
  }, [openPicker])

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept=".csv"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files?.[0]
          if (file) importFile(file)
          e.target.value = ""
        }}
      />
      <Trigger
        id="load-csv-btn"
        icon={<Upload className="h-3.5 w-3.5" strokeWidth={1.5} />}
        label="Load CSV"
        onClick={openPicker}
        size="sm"
      />
    </>
  )
}
